<template>
  <slider-cmp
    v-bind="$attrs"
    ref="slider"
    class="SliderCmpExtended"
    v-on="$listeners"
  >
    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data" />
    </template>
  </slider-cmp>
</template>

<script>
import { SliderCmp } from '@frankhoodbs/lib';

export default {
  name: 'SliderCmpExtended',
  components: { SliderCmp },
  mounted() {
    this.$watch(
      () => this.$refs.slider.swiper,
      (newValue) => {
        this.handleTabbing();
      }
    );
  },
  methods: {
    handleTabbing() {
      this.$el.addEventListener('keyup', (e) => {
        const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        if (e.shiftKey && isTabPressed) {
          if (!this.elementIsVisibleInViewport(document.activeElement)) {
            this.$refs.slider.swiper.slidePrev();
          }
        } else if (isTabPressed) {
          if (!this.elementIsVisibleInViewport(document.activeElement)) {
            this.$refs.slider.swiper.slideNext();
          }
        }
      });
    },
    elementIsVisibleInViewport(el) {
      const { top, left, bottom, right } = el.getBoundingClientRect();
      const { innerHeight, innerWidth } = window;
      return (
        top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth
      );
    },
  },
};
</script>

<style lang="scss">
#main-content .nav-variant-light {
  .swiper-pagination {
    .swiper-pagination-bullet {
      &::before {
        background: $color-grey-800;
      }
      &.swiper-pagination-bullet-active {
        &::before {
          background: $color-blue;
        }
      }
    }
  }
}
#main-content .nav-variant-dark {
  .swiper-pagination {
    .swiper-pagination-bullet {
      &::before {
        background: $color-grey-600;
      }
      &.swiper-pagination-bullet-active {
        &::before {
          background: $color-white;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.SliderCmpExtended {
  --slider-outline: calc(#{$size-outline} + #{$size-outline-offset});
  @include responsive-properties(
    (
      --slider-slide-gutter-x,
      --slider-slide-gutter-y,
      --slider-figcaption-padding
    ),
    $grid-gutter-width-resp,
    $fallback: $grid-gutter-width
  );
  --slider-custom-swipe-icon-width: 64px;
  --slider-custom-swipe-icon-height: 64px;
  --slider-custom-swipe-icon-color: #{$color-blue};
  --slider-custom-swipe-icon-pressed-color: #{$color-dark-blue};
  --slider-custom-swipe-icon-bg-color: transparent;

  ::v-deep .slider-content:not(.disabled) {
    padding-bottom: 67px;

    @include media-breakpoint-up(md) {
      padding-bottom: 82px;
    }

    .swiper-container {
      .swiper-pagination {
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px 0 15px;
        pointer-events: none;

        @include media-breakpoint-up(md) {
          padding: 55px 0 15px;
        }

        .swiper-pagination-bullet {
          position: relative;
          width: 40px;
          height: 12px;
          border-radius: 0;
          background: transparent;
          opacity: 1;
          pointer-events: auto;

          &::before {
            content: '';
            position: absolute;
            width: 100%;
            top: 5px;
            left: 0;
            height: 2px;
            border-radius: 30px;
          }
        }
      }
    }
  }
}
</style>
